'use client'

import Link from 'next/link'
import { GoogleAuthButton } from '@/components/google-auth-button'
import { reachGoal } from '@/lib/analytics'
import { plural } from '@/lib/plural'

// Вход гостя (lib/guest-lesson.ts) в одно нажатие: Google и Яндекс ID первыми,
// почта и "Войти" ниже. next ведёт через /guest-sync (guestSyncHref): уроки из
// браузера переносятся на сервер, потом открывается нужное место.
// from - метка для формы регистрации (откуда пришёл), goal - цель Метрики на нажатие.
// compact - только Google и строка со ссылками: для плашки на финале урока.
export function GuestSignInButtons({ next, from, goal, compact = false }: { next: string; from: string; goal: string; compact?: boolean }) {
  const signUp = `/auth/sign-up?from=${from}&next=${encodeURIComponent(next)}`
  const login = `/auth/login?next=${encodeURIComponent(next)}`
  if (compact) {
    return (
      <div className="flex w-full flex-col gap-2" onClickCapture={() => reachGoal(goal)}>
        <GoogleAuthButton next={next} />
        <div className="text-center text-[14px] text-fg-muted">
          Или{' '}
          <Link href={signUp} className="underline underline-offset-4" style={{ color: 'var(--tk-ice)' }}>
            Яндекс ID и почта
          </Link>
        </div>
      </div>
    )
  }
  return (
    <div className="flex w-full flex-col gap-3" onClickCapture={() => reachGoal(goal)}>
      <GoogleAuthButton next={next} />
      <GoogleAuthButton provider="yandex" next={next} />
      <Link href={signUp} className="tk-btn-primary inline-flex w-full items-center justify-center rounded-full px-8 py-4 text-[16px] font-bold">
        Зарегистрироваться почтой
      </Link>
      <div className="text-center text-[14px] text-fg-muted">
        Уже есть аккаунт?{' '}
        <Link href={login} className="underline underline-offset-4" style={{ color: 'var(--tk-ice)' }}>
          Войти
        </Link>
      </div>
    </div>
  )
}

export const lessonsWord = (n: number) => plural(n, 'урок', 'урока', 'уроков')
export const wordsWord = (n: number) => plural(n, 'слово', 'слова', 'слов')
